import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeScreenComponent } from "./welcome/home-screen/home-screen.component";
import { AuthGuard } from "./_helpers/auth.guard";
import { NotAuthGuard } from "./_helpers/not-auth.guard";

const routes: Routes = [
  {
    path: "welcome",
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "home",
        component: HomeScreenComponent,
        canActivate: [NotAuthGuard],
      },
      {
        path: "start",
        canActivate: [NotAuthGuard],
        loadChildren: () =>
          import("./welcome/start/start.module").then((m) => m.StartModule),
      },
      {
        path: "contact",
        canActivate: [NotAuthGuard],
        loadChildren: () =>
          import("./welcome/contact/contact.module").then((m) => m.ContactModule),
      },
      {
        path: "menu",
        canActivate: [AuthGuard],
        children: [
          {
            path: "",
            loadChildren: () =>
              import("./welcome/home-menu/home-menu.module").then(
                (m) => m.HomeMenuModule
              ),
          },
          {
            path: "password-update",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/password-update/password-update.module"
                  ).then((m) => m.PasswordUpdateModule),
              },
            ],
          },
          {
            path: "contact-us",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import("./welcome/contact/contact.module").then((m) => m.ContactModule),
              },
            ],
          },
          {
            path: "discover-insurrrance",
            loadChildren: () =>
              import(
                "./welcome/home-menu/discover-insurrance/discover-insurrance.module"
              ).then((m) => m.DiscoverInsurranceModule),
          },
          {
            path: "our-products-and-services",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/products-and-services/products-and-services.module"
                  ).then((m) => m.ProductsAndServicesModule),
              },
            ],
          },
          {
            path: "automobile/automobile-services",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-services/automobile-services.module"
                  ).then((m) => m.AutomobileServicesModule),
              },
            ],
          },
          {
            path: "automobile/avenants-automobile-form",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-avenant-form/automobile-avenant-form.module"
                  ).then((m) => m.AutomobileAvenantFormModule),
              },
            ],
          },
          {
            path: "automobile/avenants-automobile",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-avenant-control/automobile-avenant-control.module"
                  ).then((m) => m.AutomobileAvenantControlModule),
              },
            ],
          },
          {
            path: "automobile/automobile-quotation-form",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-quotation-form/automobile-quotation-form.module"
                  ).then((m) => m.AutomobileQuotationFormModule),
              },
            ],
          },
          {
            path: "automobile/historique-souscription",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-souscription-history/automobile-souscription-history.module"
                  ).then((m) => m.AutomobileSouscriptionHistoryModule),
              },
            ],
          },
        ],
      },
      {
        path: "thankyou",
        loadChildren: () =>
          import("./welcome/exit-screen/exit-screen.module").then(
            (m) => m.ExitScreenModule
          ),
      },
      {
        path: "intro",
        loadChildren: () =>
          import("./welcome/intro-screen/intro-screen.module").then(
            (m) => m.IntroScreenModule
          ),
      },
    ],
  },
  { path: "", redirectTo: "/welcome/home", pathMatch: "full" },
  {
    path: "**",
    redirectTo: "/welcome/home",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
